import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { ClientError } from "graphql-request";

import { graphql } from "lib/generated/app-service-gql";
import {
  DocumentFindLeadsRerunMutation,
  DocumentFindLeadsRerunMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";
import { writeFindLeadsRunning } from "./useDocumentFindLeadsCached";

// Rerun always enqueues the workflow (bypassCache=true) and returns `status: "running"`.
const documentFindLeadsRerunMutation = graphql(`
  mutation documentFindLeadsRerun($documentId: String!) {
    documentFindLeadsRerun(documentId: $documentId) {
      operationId
      status
    }
  }
`);

export function useDocumentFindLeadsRerun(
  options?: UseMutationOptions<
    DocumentFindLeadsRerunMutation,
    ClientError,
    DocumentFindLeadsRerunMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();

  return useGraphQlMutation(documentFindLeadsRerunMutation, {
    ...options,
    onSuccess: (data, variables, context) => {
      writeFindLeadsRunning(
        queryClient,
        variables.documentId,
        data.documentFindLeadsRerun.operationId,
      );
      options?.onSuccess?.(data, variables, context);
    },
  });
}
